// tslint:disable:max-line-length
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate } from "@angular/router";
import { Observable } from "rxjs";
import { TCITenantAppType, QUERY_PARAMS, TCITenantConnectionsMenu, TCI_CONNECTIONS_MENU_TYPE } from "@tci/common";
import { ITCITenantComponentInput } from "../../../../common/src/model/tci/tci-component";
import { ITCITenantNotAvailableParams } from "../ng-tenants-not-available/ng-tenants-not-available.component";

import { TCITenantMenuServices } from "../ng-tenant/tci-tenant.menu";
import { TCIRouteSelectorResolver, TCIRouteInputResolver } from "../tci-tenant-apps-route-activator";
import { NgAuthGuardService } from "../ng-shared/ng-services/ng-auth-guard.service";
import * as lodash from "lodash";

export class TciTenantConnectionsRouteActivator<I extends ITCITenantComponentInput> implements CanActivate {
    constructor(
        private tenantMenuSrv: TCITenantMenuServices,
        private authSvc: NgAuthGuardService,
        private routeResolver: TCIRouteSelectorResolver,
        private inputResolver: TCIRouteInputResolver<I>
    ) { }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.authSvc.canActivate(route, state)
            .flatMap(active => {
                if (active) {
                    return Observable.of(true);
                } else {
                    while (route.firstChild) {
                        route = route.firstChild;
                    }

                    const params: any = route.params;
                    const queryParams: any = route.queryParams;
                    const commonErrorData: ITCITenantNotAvailableParams = lodash.assign({}, params, queryParams);

                    // Evaluate the existing params
                    if (lodash.isEmpty(params) && lodash.isEmpty(queryParams)) {
                        console.warn("Route Activator: No params nor Tenant type present");
                        return Observable.of(false);
                    }

                    const requiredTenant = queryParams[QUERY_PARAMS.APP_TYPE];
                    let type: TCITenantAppType;
                    if (!requiredTenant) { // If no tenant is specified
                        console.warn("Route Activator: No tenant type defined on the route", commonErrorData);
                        return Observable.of(false);
                    } else {
                        type = TCITenantAppType.fromString(requiredTenant);
                        if (!type) { // If the tenant does not exist
                            console.warn("Route Activator: No match found for given tenant", commonErrorData);
                            return Observable.of(false);
                        }
                    }

                    const requiredComponent = params["routeid"];
                    commonErrorData[QUERY_PARAMS.COMPONENT] = requiredComponent;

                    const inputId = params["inputid"];
                    const routeOption = this.routeResolver(requiredComponent);

                    return this.inputResolver(inputId, requiredTenant, routeOption)
                        .catch(err => {
                            console.error("Connection is not available", err, commonErrorData);
                            return Observable.of(null);
                        })
                        .flatMap(inputOption => {
                            return this.tenantMenuSrv
                                .getConnectionsMenuItems(
                                    type,
                                    (v: TCITenantConnectionsMenu) => v.getOptionType() === TCI_CONNECTIONS_MENU_TYPE.HAMBURGER_MENU,
                                    inputOption
                                );
                        })
                        .map((comps: TCITenantConnectionsMenu[]) => !!comps.find(comp => comp.getRouteId() === requiredComponent));
                }
            });
    }
}
